import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel, Switch, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SizeGuideLink = ({ value, onChange, onCheckUseSizeGuide, useSizeGuide }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Guía de tallas')}</Text>
      <Switch
        checked={useSizeGuide}
        onChange={e => onCheckUseSizeGuide(e.target.checked)}
        label={t('Mostrar enlace a guía de tallas')}
      />
      {useSizeGuide && (
        <InputWithLabel
          onChange={e => onChange(e.target.value)}
          value={value}
          maxLength={110}
          fullWidth
          backgroundColor={theme.colors.background.primary}
        />
      )}
    </Styles.Container>
  )
}

export default SizeGuideLink
